var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicationDropReturnSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2775_64642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V24C28 26.2091 26.2091 28 24 28H4C1.79086 28 0 26.2091 0 24V4Z",
    fill: "#F4EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.728 11.752C11.5456 10.7775 10.6126 9.53076 9.5648 7.68878L3.83547 14.2724C2.10954 16.2557 2.31816 19.2626 4.30145 20.9885C6.28474 22.7145 9.29166 22.5059 11.0176 20.5226L11.5978 19.8558C11.0333 18.877 10.7104 17.7413 10.7104 16.5301C10.7104 14.6563 11.4834 12.9631 12.728 11.752Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.531 2.33904C18.8254 0.854807 16.2396 1.03421 14.7554 2.73975L10.3804 7.76705C11.1765 9.11809 11.9002 10.0885 12.7245 10.8614C13.9903 9.82118 15.6108 9.19671 17.3771 9.19671C18.1775 9.19671 18.9489 9.32516 19.6713 9.56293L20.9317 8.11464C22.4159 6.4091 22.2365 3.82327 20.531 2.33904ZM11.3771 16.53C11.3771 13.2163 14.0634 10.53 17.3771 10.53C18.1727 10.53 18.9305 10.6845 19.6235 10.9645L20.0642 11.1426L21.9375 8.98993C23.9052 6.7289 23.6673 3.30088 21.4063 1.33324C19.1452 -0.634407 15.7172 -0.396571 13.7496 1.86446L3.33262 13.8347C1.36498 16.0957 1.60282 19.5237 3.86385 21.4914C5.25585 22.7027 6.82515 23.0114 8.30726 22.6875C9.76184 22.3697 11.0897 21.4552 12.1008 20.2934L12.413 19.9346L12.1754 19.5227C11.6678 18.6424 11.3771 17.6212 11.3771 16.53ZM11.7745 11.7982C10.6947 13.0753 10.0438 14.7267 10.0438 16.53C10.0438 17.6845 10.311 18.7781 10.7873 19.7509C9.97214 20.5801 9.00398 21.1705 8.02266 21.3849C6.94217 21.621 5.80537 21.4134 4.73915 20.4856C3.0336 19.0013 2.8542 16.4155 4.33843 14.71L9.46007 8.82464",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.303 3.34381C19.395 2.98729 19.1806 2.62372 18.8241 2.53174C16.7054 1.98515 15.4128 3.47226 14.8973 4.06541C14.8894 4.07447 14.8817 4.08333 14.8742 4.09197C14.6325 4.36971 14.6617 4.79081 14.9395 5.03252C15.2172 5.27422 15.6383 5.24501 15.88 4.96726C16.4224 4.34401 17.2063 3.49137 18.491 3.8228C18.8475 3.91478 19.2111 3.70032 19.303 3.34381Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3769 10.5299C14.0632 10.5299 11.3769 13.2162 11.3769 16.5299C11.3769 19.8436 14.0632 22.5299 17.3769 22.5299C20.6906 22.5299 23.3769 19.8436 23.3769 16.5299C23.3769 13.2162 20.6906 10.5299 17.3769 10.5299ZM10.0436 16.5299C10.0436 12.4798 13.3268 9.19659 17.3769 9.19659C21.427 9.19659 24.7102 12.4798 24.7102 16.5299C24.7102 20.58 21.427 23.8633 17.3769 23.8633C13.3268 23.8633 10.0436 20.58 10.0436 16.5299Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2266 17.9102C12.1313 17.5546 12.3424 17.189 12.698 17.0938L21.7133 14.6781C22.069 14.5828 22.4345 14.7939 22.5298 15.1495C22.6251 15.5052 22.4141 15.8707 22.0584 15.966L13.0431 18.3817C12.6875 18.4769 12.3219 18.2659 12.2266 17.9102Z",
    fill: "#7F56D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4747 14.8793L21.9852 15.175C24.3443 16.5434 25.5031 18.9829 25.0281 21.2434L25.0285 21.2447C24.6881 22.8762 23.5326 24.16 21.8143 24.7851C22.3498 24.2885 22.7023 23.6437 22.7961 22.8671L22.7966 22.864L22.8108 22.7042C22.9222 21.0511 21.818 19.4297 20.1448 18.4971L19.621 18.2052L18.2503 20.6645L14.8241 13.3661L22.8482 12.4149L21.4747 14.8793Z",
    fill: "#7F56D9",
    stroke: "#F9F5FF",
    strokeWidth: 1.20099
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2775_64642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V24C28 26.2091 26.2091 28 24 28H4C1.79086 28 0 26.2091 0 24V4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationDropReturnSvg);
export default __webpack_public_path__ + "static/media/MedicationDropReturnSvg.61cdc0224f54724c40722ce54a3d6348.svg";
export { ForwardRef as ReactComponent };